// src/hooks/usePdfManagement.js
import { useCallback } from 'react';
import config from '../config';

const host = config.backendUrl;

export default function usePdfManagement({
  order,
  pdf,
  setPdf,
  authToken,
  setLoadingPdf,
}) {
  const checkPdfStatus = useCallback(
    (orderId, itemIndex, attempts = 0) => {
      if (attempts >= 10) {
        alert('PDF generation took too long.');
        setLoadingPdf(false);
        return;
      }

      fetch(`${host}/api/admin/pdf-status/${orderId}/${itemIndex}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.status === 'complete') {
            if (data.pdf_url === pdf[itemIndex]) {
              setTimeout(() => checkPdfStatus(orderId, itemIndex, attempts + 1), 10000);
            } else {
              setPdf((prev) => {
                const newPdf = [...prev];
                newPdf[itemIndex] = data.pdf_url;
                return newPdf;
              });
              order.items[itemIndex].pdf_url = data.pdf_url;
              setLoadingPdf(false);
            }
          } else if (data.status === 'in progress') {
            setTimeout(() => checkPdfStatus(orderId, itemIndex, attempts + 1), 10000);
          } else {
            alert('PDF generation failed.');
            setLoadingPdf(false);
          }
        })
        .catch((err) => {
          console.error('Error checking PDF status:', err);
          setLoadingPdf(false);
        });
    },
    [authToken, pdf, setPdf, setLoadingPdf, order]
  );

  const generatePDF = useCallback(
    (itemIndex) => {
      setLoadingPdf(true);
      setPdf((prev) => {
        const newPdf = [...prev];
        newPdf[itemIndex] = null;
        return newPdf;
      });

      fetch(`${host}/api/admin/generate-pdf/${order.id}/${itemIndex}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((res) => res.json())
        .then(() => {
          setTimeout(() => checkPdfStatus(order.id, itemIndex), 10000);
        })
        .catch((err) => {
          console.error('Error generating PDF:', err);
          setLoadingPdf(false);
        });
    },
    [authToken, order, setPdf, checkPdfStatus, setLoadingPdf]
  );

  const clearPDF = useCallback(
    (itemIndex) => {
      if (!pdf[itemIndex]) {
        alert('No existing PDF');
        return;
      }

      setPdf((prev) => {
        const newPdf = [...prev];
        newPdf[itemIndex] = null;
        return newPdf;
      });

      fetch(`${host}/api/admin/clear-pdf/${order.id}/${itemIndex}`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.message === 'success') {
            alert('Successfully cleared PDF. OK to generate new one.');
          }
        })
        .catch((err) => console.error('Error clearing PDF:', err));
    },
    [authToken, order, pdf, setPdf]
  );

  return {
    generatePDF,
    clearPDF,
  };
}